var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n        © "+_vm._s(new Date().getFullYear())+" Teatro Musicado, desenvolvido por"),_c('a',{attrs:{"href":"https://espressolabs.com.br","target":"_blank"}},[_vm._v(" EspressoLabs ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }